/**
 * Module Loader
 *
 * Auto-discovers modules from the modules/ directory via Vite's import.meta.glob().
 * Each module must have a Resources/js/module.js that exports { routes, nav, ... }.
 *
 * Legacy modules in resources/js/modules/*.js are still supported and take precedence
 * (i.e., if a slug exists in both, the legacy version wins — allowing incremental migration).
 */

// Auto-discover modules from the modules/ directory
const externalModules = import.meta.glob('/modules/*/Resources/js/module.js', { eager: true });

/**
 * Parse discovered module files into a flat array of module definitions.
 * The slug is read from the module's exported `slug` property, or derived from the directory name.
 */
export function getExternalModules() {
    return Object.entries(externalModules).map(([path, mod]) => {
        const def = mod.default || mod;

        // Derive slug from path: /modules/Equipment/Resources/js/module.js → "equipment"
        const match = path.match(/\/modules\/([^/]+)\//);
        const dirName = match ? match[1].toLowerCase() : null;

        return {
            ...def,
            _source: 'external',
            _dirSlug: dirName
        };
    });
}

/**
 * Register global Vue components contributed by modules.
 * Each module can export a `components(app)` function in its module.js
 * to register its own global components (e.g., app-addresses, app-tasks).
 */
export function registerModuleComponents(app) {
    for (const mod of Object.values(externalModules)) {
        const def = mod.default || mod;
        if (typeof def.components === 'function') {
            def.components(app);
        }
    }
}
